

import { motion } from "framer-motion";



export default function FloatingElement({ x, y, color, size, delay }) {

    return (

        <motion.div
            className={`absolute rounded-full blur-2xl opacity-10 ${color}`}
            style={{
                left: `${x}%`,
                top: `${y}%`,
                width: `${size}px`,
                height: `${size}px`,
            }}
            animate={{
                y: [0, -20, 0],
                scale: [1, 1.1, 1],
            }}
            transition={{
                duration: 4,
                repeat: Infinity,
                delay,
                ease: "easeInOut"
            }}
        />

    )
};
